if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".sym-slides").slick();

  //(link functionality to menus)
  const searchParams = () => {
    if (window.location.search) {
      const URL = window.location.search.slice(1);
      let paramsURL = URL.split("&");
      paramsURL.forEach((param) => {
        let value = param.split("=")[0];
        let key = param.split("=")[1];
        console.log(key);

        switch (value) {
          case "quad": // option quad
            scrollQuad(key);
            break;
          case "clic": // option clic in element
            // console.log(key);
            clicElement(key);
            break;
          default:
        }
      });
    }
  };

  const scrollQuad = (selectorElement) => {
    if (selectorElement === null || selectorElement === "") return;

    let target = document.querySelector(`#${selectorElement}`);
    if (target === null) {
      target = document.querySelector(`.${selectorElement}`);
    }
    if (target === null) {
      target = document.querySelector(`[data-tb-quad="${selectorElement}"]`);
    }
    if (target === null) {
      console.error(
        `ERROR: there is no element with the class, id or data attribute "${selectorElement}"`
      );
      return;
    }

    setTimeout(() => {
      $("html, body").animate({ scrollTop: $(target).offset().top - 100 }, 800);
    }, 600);
  };

  const clicElement = (selectorElement) => {
    if (selectorElement === null || selectorElement === "") return;

    let nodeElement = document.querySelector(
      `[data-menuid="${selectorElement}"]`
    );
    if (nodeElement === null) {
      console.error(`ERROR: it is not possible to found the element`);
      return;
    }

    setTimeout(() => {
      nodeElement.click();
      onScrollAuto(nodeElement);
    }, 200);
  };

  const onValidParam = (param) => {
    const URL = window.location.search.slice(1);

    if (URL.indexOf(param) === 0) return true;
    return false;
  };

  const onScrollAuto = (sourceSelector) => {
    console.log(sourceSelector);
    let htmlQuad = sourceSelector.closest("[data-tb-quad]");
    let idQuad =
      htmlQuad.getAttribute("id") === null
        ? htmlQuad.dataset.tbQuad
        : htmlQuad.getAttribute("id");

    console.log(idQuad);
    scrollQuad(idQuad);
  };

  searchParams();
  //(link functionality to menus)

  function searchParamsMenu() {
	var hash = window.location.hash;
	hash = hash.replace('#', '');
	console.log(hash);
	if (hash == 'menu-magical-dining') {
		if (document.querySelector('#menu-magical-dining')) {
			document.querySelector('#menu-magical-dining').click();
		}
	}
  }

  searchParamsMenu();

  // console.log(getUrlParameters());
})();
